import { CampusApiService } from 'services/client-api-wrapper';
import { getApiGatewayUrl } from 'kits/urlKit';

export const resourceService = new CampusApiService(getApiGatewayUrl('res', 'default'));
